import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<string>} */
const initialState = [];

/**
 * @param {Array<string>} _
 * @param {import('modules/statistics/types').FetchDealersStatsBrandsSuccessAction} action
 * @returns {Array<string>}
 */
const updateAllData = (_, { payload }) => payload.brands.map(brand => brand.id ?? brand.brandId) ?? [];

const reset = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_INTERVENTION_BRANDS_SUCCESS]: updateAllData,
  [types.FETCH_STATISTICS_INTERVENTION_BRANDS_REQUEST]: reset,
});
